/* Bettr — PDP Materials carousel controller.
   Mirrors the proven scroll-snap + arrow nav + dots pattern from
   custom-lineup.js. Scoped per section, full teardown on
   shopify:section:unload to avoid Theme Editor listener leaks. */

(function () {
  'use strict';

  function bootSection(section) {
    if (!section || section.__bettrMatBooted) return;
    section.__bettrMatBooted = true;

    var slider = section.querySelector('[data-materials-slider]');
    if (!slider) return;

    var teardown = [];
    function on(target, event, handler, opts) {
      target.addEventListener(event, handler, opts);
      teardown.push(function () { target.removeEventListener(event, handler, opts); });
    }

    var prevBtn = section.querySelector('[data-materials-prev]');
    var nextBtn = section.querySelector('[data-materials-next]');
    var dotsContainer = section.querySelector('[data-materials-dots]');
    var dots = dotsContainer ? dotsContainer.querySelectorAll('[data-materials-dot]') : [];

    function getCardStep() {
      var card = slider.querySelector('.custom-pdp-mat-card');
      if (!card) return 320;
      var styles = window.getComputedStyle(slider);
      var gap = parseFloat(styles.columnGap || styles.gap || '20') || 20;
      return card.offsetWidth + gap;
    }

    function activeIndex() {
      var step = getCardStep();
      if (step <= 0) return 0;
      return Math.round(slider.scrollLeft / step);
    }

    function updateUI() {
      var idx = activeIndex();
      if (dots.length) {
        for (var i = 0; i < dots.length; i++) {
          var isActive = (i === idx);
          dots[i].classList.toggle('is-active', isActive);
          dots[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
      }
      if (prevBtn) prevBtn.disabled = slider.scrollLeft <= 2;
      if (nextBtn) {
        nextBtn.disabled = (slider.scrollLeft + slider.clientWidth) >= (slider.scrollWidth - 2);
      }
    }

    var scrollPending = false;
    on(slider, 'scroll', function () {
      if (scrollPending) return;
      scrollPending = true;
      window.requestAnimationFrame(function () {
        scrollPending = false;
        updateUI();
      });
    }, { passive: true });

    if (prevBtn) {
      on(prevBtn, 'click', function () {
        slider.scrollBy({ left: -getCardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      on(nextBtn, 'click', function () {
        slider.scrollBy({ left: getCardStep(), behavior: 'smooth' });
      });
    }

    for (var d = 0; d < dots.length; d++) {
      (function (i, dot) {
        on(dot, 'click', function () {
          slider.scrollTo({ left: i * getCardStep(), behavior: 'smooth' });
        });
        on(dot, 'keydown', function (e) {
          if (e.key === 'ArrowLeft' && i > 0) {
            e.preventDefault();
            dots[i - 1].focus();
            dots[i - 1].click();
          }
          if (e.key === 'ArrowRight' && i < dots.length - 1) {
            e.preventDefault();
            dots[i + 1].focus();
            dots[i + 1].click();
          }
        });
      })(d, dots[d]);
    }

    on(slider, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        slider.scrollBy({ left: -getCardStep(), behavior: 'smooth' });
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        slider.scrollBy({ left: getCardStep(), behavior: 'smooth' });
      }
    });

    var resizePending = false;
    on(window, 'resize', function () {
      if (resizePending) return;
      resizePending = true;
      window.requestAnimationFrame(function () {
        resizePending = false;
        updateUI();
      });
    }, { passive: true });

    updateUI();

    document.addEventListener('shopify:section:unload', function handler(e) {
      var sectionWrap = section.closest('.shopify-section');
      if (!sectionWrap || !e.target || !e.target.contains(sectionWrap)) return;
      teardown.forEach(function (fn) { try { fn(); } catch (err) {} });
      teardown.length = 0;
      section.__bettrMatBooted = false;
      document.removeEventListener('shopify:section:unload', handler);
    });
  }

  function bootAll() {
    document.querySelectorAll('.custom-pdp-mat').forEach(bootSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var section = e.target.querySelector('.custom-pdp-mat');
    if (section) bootSection(section);
  });
})();
